module.exports = __webpack_public_path__ + "media/images/contract/signature-f08a1d371a757253f6f56e6b1fc32021.jpg";